import { makeStyles } from '@mui/styles';
import { IconButton, Tooltip } from 'apollo-react';
import Redo from 'apollo-react-icons/Redo';
import Undo from 'apollo-react-icons/Undo';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from './../../../../custom-hooks/useTranslation';
import { getUserActionPointer, getUserActionsArray } from './../../../selectors/common.selectors';
import { useFormSelector } from '../../../../custom-hooks';
import { getUITA } from '../../../../utils/commonUtils';
import { redoUserAction, undoUserAction } from '../../../actions/editor.actions';
import { equalityFn } from '../../../utils/form-manager.utils';

const useStyles = makeStyles({
  buttonContainer: {
    display: 'flex',
  },
  actionButton: {
    paddingTop: '4px',
    width: '22px',
    height: '22px',
  },
});

const UserChangesButton = () => {
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();

  const actions = useFormSelector(getUserActionsArray, {}, equalityFn);
  const actionPointer = useFormSelector(getUserActionPointer);

  const shouldDisableRedoButton = actionPointer === 0;
  const shouldDisableUndoButton = !actions.length || !actions[actionPointer];

  const handleRedoButtonClick = () => dispatch(redoUserAction());
  const handleUndoButtonClick = () => dispatch(undoUserAction());

  return (
    <div className={classes.buttonContainer}>
      <Tooltip
        title={shouldDisableUndoButton ? null : translateString('Undo Action')}
        placement="top"
      >
        <IconButton
          aria-label={translateString('Undo Action')}
          style={{ marginRight: 5 }}
          size="small"
          onClick={handleUndoButtonClick}
          ui-ta={getUITA('undo-action')}
          disabled={shouldDisableUndoButton}
        >
          <Undo fontSize="small" className={classes.actionButton} />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={shouldDisableRedoButton ? null : translateString('Redo Action')}
        placement="top"
      >
        <IconButton
          aria-label={translateString('Redo Action')}
          style={{ marginRight: 5 }}
          size="small"
          onClick={handleRedoButtonClick}
          ui-ta={getUITA('redo-action')}
          disabled={shouldDisableRedoButton}
        >
          <Redo fontSize="small" className={classes.actionButton} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default UserChangesButton;
